import React from "react";
import { Box, Typography, Paper, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

// Import the existing KanbanBoard component instead of duplicating functionality
import KanbanBoard from "../../boards/components/KanbanBoard";

const RecruitingBoardGrid = ({
  columns: initialColumns,
  onColumnsUpdate,
  onRecruitUpdate,
}) => {
  // If no columns, show empty state
  if (!initialColumns || initialColumns.length === 0) {
    return (
      <Paper sx={{ p: 4, textAlign: "center" }}>
        <Typography variant="h6" gutterBottom>
          No columns yet
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Add columns to start organizing your recruits
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            // This will be handled by the parent component
            // For now, just show a placeholder
            console.log("Add column functionality should be handled by parent");
          }}
        >
          Add Column
        </Button>
      </Paper>
    );
  }

  // Simply render the existing KanbanBoard component with the provided props
  return (
    <Box sx={{ overflowX: "auto", pb: 2 }}>
      <KanbanBoard
        columns={initialColumns}
        onColumnsUpdate={onColumnsUpdate}
        onRecruitUpdate={onRecruitUpdate}
      />
    </Box>
  );
};

export default RecruitingBoardGrid;
